import React, { useContext, useEffect, useState } from 'react';
import { ThemeProvider, lightTheme } from '@comfama/comfama-ui';
import './App.css';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './shared/src/components/organisms/layout/layout';
import authContext, { IGigyaAccount } from './shared/src/contexts/authContext';
import NotLogged from './components/organisms/not-logged/notLogged';
import { getToken } from 'shared/src/services/user-info.service';
import { getChallenges, getUserState } from './services/routeServices';
import RouteNew from './components/organisms/route-new/routeNew';
import ChallengesDashboard from 'components/organisms/challenges-dashboard/challengesDashboard';
import challengesAdapter, { IChallenges } from 'adapters/challenges.adapter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RouteCredits from 'components/organisms/route-credits/route-credits/RouteCredits';
import CourseCredits from 'components/organisms/route-credits/CourseCredits';


function App() {

	const context = useContext(authContext);
	const [challenges, setChallenges] = useState<IChallenges[] | null>(null);
	const location = useLocation();
	const [personalToken, setPersonalToken] = useState<string | any>(null);


	const listPathName = ["/curso-credito", "/dashboard-course-credits"]

	const validateData = async () => {
		if (!listPathName.includes(location.pathname)) {
			try {
				const userState = await getUserState();
				if (!userState.data.data.hasDiagnostic) {
					window.location.replace(process.env.REACT_APP_REDIRECT_URL + '/');
				}
			} catch (error) {
				console.log(`Error validate: ${error}`)	
			}
		}
	}

	const getUserChallenges = async (jwt: string) => {
		try {
			const resChallenges:string|any = await getChallenges(jwt);
			setChallenges(challengesAdapter(resChallenges.data.data));
		} catch (error) {
			console.error(error);
		}
	}

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname])

	useEffect(() => {
		if (! context.gigyaAccount) return;

		async function getPersonalToken(UID: string): Promise<void> {
			try {
				if (context.gigyaAccount) {
					const response = await getToken(UID);
					setPersonalToken(response);
				}
			} catch (error) {
				console.log(`Error getPersonalToken: ${error}`)
			}
		}
		
		getPersonalToken(context.gigyaAccount.UID);
	}, [context.gigyaAccount])
	

	useEffect(() => {
		validateData();
	}, []);
	

	useEffect(() => {
		if (personalToken !== null) {
			getUserChallenges(personalToken);
		}
	}, [personalToken]);

	// useEffect(() => {
	// 	if (!context.gigyaAccount)  return;
	// 		setUID(context.gigyaAccount.UID);
	// }, [context.gigyaAccount]);

	if (!context.gigyaAccount && !context.loading) {
		return (
			<Layout>
				<NotLogged />
			</Layout>
		)
	}

	return (
		<Layout notifySys={{ container: ToastContainer, toast }}>
			<Routes>
				<Route path='/' element={<RouteNew challenges={challenges} />} />
				<Route path='/curso-credito' element={<RouteCredits />} />
				<Route path='/dashboard-course-credits' element={<CourseCredits />} />
				<Route path='/dashboard' element={<ChallengesDashboard challenges={challenges} setChallenges={setChallenges} />} />
				<Route path='*' element={<Navigate to="/" />} />
			</Routes>
		</Layout>
	);
}

export default App;
function async(gigyaAccount: IGigyaAccount) {
	throw new Error('Function not implemented.');
}

